import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import ViewAdminUser from './ViewAdminUser';

const AdminUserHome = () => {

    return (
        <Box sx={{ width: '100%' }}>
            <ViewAdminUser />
        </Box>
    );
}

export default AdminUserHome;